import AlertService from './alert';

/**
 * Servicio para manejar respuestas MgkMessage del backend
 * Analiza la respuesta y muestra alertas apropiadas usando SweetAlert2
 */
export const MgkResponseHandler = {
  /**
   * Procesa una respuesta MgkMessage y muestra la alerta correspondiente
   * @param {Object} response - Respuesta del servidor que contiene un MgkMessage
   * @param {Object} options - Opciones adicionales para personalizar la alerta
   * @returns {Promise} - Promesa que se resuelve con el resultado de la alerta
   */
  handleResponse(response, options = {}) {
    // Verificar si la respuesta es válida
    if (!response) {
      return AlertService.error('No se recibió respuesta del servidor');
    }

    // Extraer el mensaje MgkMessage
    const mgkMessage = JSON.parse(response.headers["mgkmessage"]);

    // Verificar que sea un objeto MgkMessage válido
    if (!mgkMessage || typeof mgkMessage !== 'object') {
      return AlertService.error('Formato de respuesta inválido');
    }

    // Extraer los campos relevantes
    const message = mgkMessage.Message || mgkMessage.Messagex || 'Operación completada';
    const title = mgkMessage.Title || this.getDefaultTitle(mgkMessage.Type);
    const type = mgkMessage.Type ? mgkMessage.Type.toLowerCase() : 'info';

    // Mostrar la alerta según el tipo
    switch (type) {
      case 'success':
        return AlertService.success(message, title, options);
      case 'error':
        return AlertService.error(message, title, options);
      case 'warning':
        return AlertService.warning(message, title, options);
      case 'info':
      default:
        return AlertService.info(message, title, options);
    }
  },

  /**
   * Obtiene un título predeterminado según el tipo de mensaje
   * @param {string} type - Tipo de mensaje (success, error, warning, info)
   * @returns {string} - Título predeterminado
   */
  getDefaultTitle(type) {
    if (!type) return 'Información';

    switch (type.toLowerCase()) {
      case 'success':
        return 'Éxito';
      case 'error':
        return 'Error';
      case 'warning':
        return 'Advertencia';
      case 'info':
      default:
        return 'Información';
    }
  }
};

export default MgkResponseHandler;
